import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { combineValidators, isRequired } from 'revalidate';
import {
  Button,
  Form,
  FormGroup,
  Modal,
  ModalBody,
  ModalHeader
} from 'shards-react';
import { addNewAgent } from '../../../../pages/Agents/agentActions';
import TextInput from '../../../form/TextInput';
import { closeModal } from '../../modalActions';
import SelectInput from '../../../form/SelectInput';

const mapState = state => ({
  profile: state.profile
});

const actions = {
  closeModal,
  addNewAgent
};

const validate = combineValidators({
  displayName: isRequired('display name'),
  email: isRequired('email'),
  password: isRequired('password'),
  role: isRequired('role')
});

class AddNewAgent extends Component {
  render() {
    const { closeModal, handleSubmit, error, addNewAgent } = this.props;
    const lower = value => value && value.toLowerCase();
    return (
      <Modal
        className="col-md-8 col-lg-8"
        open={true}
        toggle={closeModal}
        modalClassName="modal"
        fade={true}
        role="dialog"
      >
        <ModalHeader className="bg-primary1">Add New Agent</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit(addNewAgent)}>
            <FormGroup className="text-left">
              <label htmlFor="displayName">Display Name</label>
              <Field
                name="displayName"
                type="text"
                placeholder="Enter your short name"
                component={TextInput}
                normalize={lower}
              />
            </FormGroup>
            <FormGroup className="text-left">
              <label htmlFor="email">Email</label>
              <Field
                name="email"
                type="email"
                placeholder="Enter Email"
                component={TextInput}
                normalize={lower}
              />
            </FormGroup>

            <FormGroup className="text-left">
              <label htmlFor="email">Type</label>
              <Field
                name="role"
                type="select"
                component={SelectInput}
                options={[
                  { label: 'Senior Agent', value: 'agent' },
                  { label: 'Temp Agent', value: 'temp-agent' }
                ]}
                placeholder="Select a role type"
              />
            </FormGroup>
            <FormGroup className="text-left">
              <label htmlFor="password">Password</label>
              <Field
                name="password"
                component={TextInput}
                type="password"
                placeholder="Enter Password"
              />
            </FormGroup>
            <div className="home-buttons d-flex w-100 justify-content-between px-3">
              <Button theme="danger" name="dismiss" onClick={closeModal}>
                Dismiss
              </Button>
              <Button theme="success" type="submit" className="text-center">
                Add Agent
              </Button>
            </div>
            <div className="text-center mx-auto">
              {error && <label className="error-label">{error}</label>}
            </div>
          </Form>
        </ModalBody>
      </Modal>
    );
  }
}

export default compose(
  connect(mapState, actions),
  reduxForm({ form: 'newAgentForm', validate })
)(AddNewAgent);
